import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type EnableWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.EnableWebhookInput;
}>;

export type EnableWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsEnableWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'EnableWebhookPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const EnableWebhookDocument = gql`
  mutation enableWebhook($input: EnableWebhookInput!) {
    webhookSubscriptionsEnableWebhook(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
